
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/developers/paid-social-media-advertising",
      function () {
        return require("private-next-pages/products/developers/paid-social-media-advertising.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/developers/paid-social-media-advertising"])
      });
    }
  